import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import { FormattedMessage } from 'react-intl';
import ModalActionCreator from 'action_creators/modal';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import ModalContent from './modal_content';
import './index.scss';

class ContactGuide extends React.Component {
  static displayName = 'TourPage-ContactGuide';

  static propTypes = {
    guideId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    guidePictureUrl: PropTypes.string,
    guideName: PropTypes.string,
    isCompany: PropTypes.bool,
  };

  getDefaultProperties = () => {
    return {
      guidePictureUrl: null,
      guideName: '',
      isCompany: false,
    };
  };

  _contactLinkClicked = (e) => {
    e.preventDefault();
    ModalActionCreator.show({
      content: this._contactModal(),
      triggeringElement: e.currentTarget,
    });
    $('body').addClass('modal-open');
  };

  _contactModal = () => {
    return <ModalContent {...this.props} />;
  };

  render() {
    return (
      <div className="TourPage-ContactGuide">
        <button
          type="button"
          data-testid="contact-link"
          className="TourPage-ContactGuide-link ui basic button brand-border"
          onClick={this._contactLinkClicked}
          onKeyDown={(e) => isActionKey(e.key) && this._contactLinkClicked(e)}
          title="If you have any question, Contact Us"
          aria-label="If you have any question, Contact Us"
          id="contact-us-btn"
        >
          <i className="icon anyfont af-envelope brand-color" />
          <span
            className="ContactGuide-link-text brand-color"
            aria-labelledby="contact-us-btn"
          >
            <FormattedMessage
              id="QUESTIONS_CONTACT_US"
              defaultMessage="Questions? Contact us"
              description="Link text inviting users to contact with questions"
            />
          </span>
        </button>
      </div>
    );
  }
}

export default ContactGuide;
